/** @format */

import { Chain, LoginType, SSO_TYPE } from "interfaces";
import { store } from "reducer/store";

const eventBox = require("./event-box.json");

export const SSO_META = () => {
  let SSO_META: SSO_TYPE = store.getState().ssometa.meta;
  return SSO_META;
};

export const IS_PRODUCTION_MODE = () => {
  // return process.env.REACT_APP_PRODUCTION;
  let SSO_META: SSO_TYPE = store.getState().ssometa.productionMode;
  return SSO_META;
};

export const SSO_CONTRACT = () => store.getState().ssometa.contract;

const BoxData = eventBox;

const Config = {
  ApiHost: process.env.REACT_APP_API_HOST,
  ProductionMode: process.env.REACT_APP_PRODUCTION,

  MetamaskExtension: process.env.REACT_APP_METAMASK_EXTENSION,
  TerraExtension: process.env.REACT_APP_TERRA_EXTENSION,
  KeplrExtension:
    process.env.REACT_APP_KEPLR_EXTENSION ??
    "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en",

  TerraGasAdjusment: process.env.REACT_APP_GAS_ADJUSTMENT,
  lcdTerraUrl: process.env.REACT_APP_TERRA_URL,
  lcdTerraChainID: process.env.REACT_APP_TERRA_CHAINID,
  TerraGasUrl: process.env.REACT_APP_TERRA_GAS_URL,

  SupportedAuth: [
    LoginType.BSC,
    LoginType.Terra,
    LoginType.Avalanche,
    LoginType.Okex,
    LoginType.Email,
    LoginType.Facebook,
    LoginType.Google,
    LoginType.Apple,
  ],
  AntiWalletAuth: [
    LoginType.Email,
    LoginType.Facebook,
    LoginType.Google,
    LoginType.Apple,
  ],
  ChainAuth: [
    LoginType.BSC,
    LoginType.Terra,
    LoginType.Avalanche,
    LoginType.Okex,
    LoginType.Aura,
  ],

  EtherChain: [Chain.BSC, Chain.Avalanche, Chain.Okex],
  CosmosChain: [Chain.Aura],

  MainnetUnsupportedChain: [
    LoginType.Terra,
    LoginType.Farmer,
    LoginType.Google,
    LoginType.Facebook,
    LoginType.Okex,
  ],
  BoxData: BoxData,

  Social: {
    Web: "https://monsterra.io/",
    Twitter: "https://monsterra.io/",
    Discord: "https://discord.com/invite/TtqbsdY9CW",
    Facebook: "https://www.facebook.com/Monsterra-P2E-Game-100591379141319",
    Telegram: "https://t.me/monsterragame",
    Youtube: "https://www.youtube.com/channel/UCjTCP6BkSrPS5bDs0JkJBjg",
    Tiktok: "https://vt.tiktok.com/ZSR1BMhSR/",
    HomeTelegram: "https://t.me/monsterragame",
  },

  FormattedTime: {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  },

  FormattedDate: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  },

  FormattedDateLong: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  },

  MinStakeAlert: 2000,

  // item[points: rarity[], type]
  NftStakePoint: [
    {
      points: [5, 65, 237, 678, 1695],
      type: 0,
    },
    {
      points: [13, 627, 1016, 3703, 9258],
      type: 3,
      plot_type: 0,
    },
    {
      points: [7, 214, 428, 885, 2213],
      type: 3,
      plot_type: 1,
    },
    {
      points: [13, 1424, 3820, 6505, 16263],
      type: 3,
      plot_type: 2,
    },
    {
      points: [13, 1796, 3252, 7079, 17698],
      type: 3,
      plot_type: 3,
    },
    {
      points: [11, 1029, 2085, 5232, 13080],
      type: 3,
      plot_type: 4,
    },
    {
      points: [11, 1383, 3297, 6171, 15428],
      type: 3,
      plot_type: 5,
    },
    {
      points: [70, 1392, 5348, 9627, 24068],
      type: 3,
      plot_type: 6,
    },
    {
      points: [30, 696, 8023, 10464, 26160],
      type: 3,
      plot_type: 7,
    },
    {
      points: [62, 930, 6334, 18514, 46285],
      type: 3,
      plot_type: 8,
    },
    {
      points: [14, 746, 1866, 5016, 12540],
      type: 3,
      plot_type: 9,
    },
    {
      points: [26, 1688, 2326, 6877, 17193],
      type: 3,
      plot_type: 10,
    },
  ],
};
export default Config;
